/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {businessCardIcon} from "./index";


function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput('VALUE')
                .appendField("get")
                .appendField(new Blockly.FieldImage(businessCardIcon, 30, 30, "business card icon", null), 'businessCardIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, "businesscard", undefined, '- select -'), "ID")
                .appendField("field")
                .appendField(new Blockly.FieldDropdown([['Name','Name'],['Title','Title'],['Email','Email'],['Phone','Phone'],['Company','Company']],undefined,'- select -'), "TARGET")

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, ["String", "Number"]);
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the value of a property from a business card widget');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#widget-values');
        },

        onchange: function(){
            if (this.getField('businessCardIcon')?.imageElement_) {
                this.getField('businessCardIcon').setTooltip('BusinessCard');
            }
        }
    }
}

function defineGenerators(){
    return {
        'JavaScript': function(block){
            let id = block.getFieldValue('ID');
            let field = block.getFieldValue('TARGET');
            let code = `Snap.widgets.businesscardreader.get${field}("${id}")`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetBusinessCardValue = function (props) {
    const name = 'snap_get_businesscard_value';
    GetBusinessCardValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget?.id ?
                <field name='ID'>{props.widget.id}</field>
                : null
            }
        </block>
    );
}

GetBusinessCardValue.propTypes = {
    context: PropTypes.object.isRequired,
    widgets: PropTypes.array.isRequired,
    widget: PropTypes.object,
};

export default GetBusinessCardValue;
